"use client";

import { c as _c } from "react/compiler-runtime";
import { PayPalMessages } from "@paypal/react-paypal-js";
import { IconLock } from "@tabler/icons-react";
import { useCart } from "@/queries/useCart";
import { PaymentMethodIcons } from "./PaymentMethodIcons";
interface Props {
  headline: string;
}
export function PaymentSection(t0) {
  const $ = _c(9);
  const {
    headline
  } = t0;
  const {
    data: cart
  } = useCart();
  const grandTotal = cart?.pricing?.grandTotal ?? 0;
  const paypalConfigured = Boolean(process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID);
  let t1;
  if ($[0] !== headline) {
    t1 = <h2 className="text-2xl">{headline}</h2>;
    $[0] = headline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2"><IconLock className="size-4 text-green-600" aria-hidden="true" /><p className="text-sm text-green-600">SSL secured</p><p className="text-sm text-neutral-500">with 256-bit encryption</p></div>;
    t3 = <PaymentMethodIcons />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== grandTotal) {
    t4 = paypalConfigured && grandTotal > 0 && <PayPalMessages amount={grandTotal} forceReRender={[grandTotal]} />;
    $[4] = grandTotal;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = <section className="space-y-2 px-5 pt-12">{t1}{t2}{t3}{t4}</section>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}